import Loadable from "app/components/Loadable";
import { lazy } from "react";

const FieldAttendanceLog = Loadable(lazy(() => import("./FieldAttendanceLog")));
const FieldAttendanceLogForm = Loadable(lazy(() => import("./FieldAttendanceLogForm")));
const DailyAttendanceSummary = Loadable(
  lazy(() => import("./DailyAttendanceSummary"))
);

const attendanceRoutes = [
  {
    path: "/Attendance/FieldAttendanceLog",
    element: <FieldAttendanceLog />,
  },
  {
    path: "/Attendance/FieldAttendanceLogForm",
    element: <FieldAttendanceLogForm />,
  },
  {
    path: "/Attendance/FieldAttendanceLogForm/:attendanceId",
    element: <FieldAttendanceLogForm />,
  },
  {
    path: "/Attendance/DailyAttendanceSummary",
    element: <DailyAttendanceSummary />,
  },
];
export default attendanceRoutes;
